import { Box, type SvgIconProps, type SxProps, Typography } from '@mui/material';
import type { ComponentType, FC, ReactNode } from 'react';

import { palette } from '@web/theme/palette';

// TODO: the colors from palette look ugly. Need to re-align it with the designers

export const errorKind = {
  backgroundColor: '#FFEAF0',
  borderColor: '#FFEAF0',
  accentColor: '#EE1C51',
  titleColor: '#EE1C51',
};

export const infoKind = {
  backgroundColor: palette.SlabBlue.IceLight,
  borderColor: palette.SlabBlue.IceLight,
  accentColor: palette.SlabTurquoise[600],
};

export const warningKind = {
  backgroundColor: '#FFF4E6',
  borderColor: '#FFDDC1',
  accentColor: palette.SlabYellow[800],
};

export const okKind = {
  borderColor: '#D3F1DB',
  backgroundColor: '#E6F7ED',
  accentColor: palette.SlabGreen[600],
};

type StatusBoxStyle = {
  borderColor: string;
  backgroundColor: string;
  accentColor: string;
  titleColor?: string;
};

type StatusBoxProps = {
  sx?: SxProps;
  title?: string;
  subtitle?: string;
  icon: ComponentType<SvgIconProps>;
  kind: StatusBoxStyle;
  attachBody?: boolean;
  children?: ReactNode;
};

export const StatusBox: FC<StatusBoxProps> = ({
  icon: Icon,
  kind,
  title,
  subtitle,
  children,
  attachBody,
  sx,
}) => {
  const titleTypographySx = kind.titleColor ? { color: kind.titleColor } : null;

  return (
    <Box
      sx={{
        border: `1px solid ${kind.borderColor}`,
        borderRadius: '0.5rem',
        backgroundColor: kind.backgroundColor,
        display: 'flex',
        flexDirection: 'column',
        ...sx,
      }}
    >
      <Box
        sx={{
          padding: '1rem 1rem 0.5rem 1rem',
          display: 'flex',
          gap: '0.5rem',
        }}
      >
        <Box>
          <Icon sx={{ width: '25px', height: '25px', color: kind.accentColor }} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {title ? (
            <Typography variant='h6' sx={titleTypographySx}>
              {title}
            </Typography>
          ) : undefined}
          {subtitle ? <Typography variant='secondary'> {subtitle} </Typography> : undefined}
        </Box>
      </Box>
      {children && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: attachBody ? 'white' : kind.backgroundColor,
            paddingTop: attachBody ? '1rem' : null,
            paddingLeft: '1rem',
            paddingBottom: '1rem',
            paddingRight: '1rem',
            borderTop: attachBody ? `1px solid ${kind.borderColor}` : null,
            borderBottomLeftRadius: '0.5rem',
            borderBottomRightRadius: '0.5rem',
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  );
};
